import { Injectable } from '@angular/core';
import { Language } from '../../enums/language.enum';
import 'rxjs/add/operator/map'
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { debug, error } from 'util';


@Injectable({
  providedIn: 'root'
})
export class ResourceService {

  private language: Language;
  private languageList = [{ Id: Language.English, Name: "en" }, { Id: Language.Arabic, Name: "ar" }, { Id: Language.Urdu, Name: "ur" }]
  constructor(private http: HttpClient) { }

  getResources(serviceFolder: string, resourceFileName: string): Observable<any> {

    return new Observable<any>(observer => {
      this.getCulture().subscribe(lang => {
        let filePath;
        this.language = <Language>lang;
        this.getGlobalResources(this.language).subscribe(globalRes => {
          if (globalRes != undefined) {
            //debugger;
            //added below on 20240724 start
            if (window.location.href.toLowerCase().indexOf("/ar-ae/") > 0) {
              this.language = 1;
            }
            else if (window.location.href.toLowerCase().indexOf("/en/") > 0) {
              this.language = 2;
            }
            else if (window.location.href.toLowerCase().indexOf("/ur-pk/") > 0) {
              this.language = 3
            }
            //added below on 20240724 End
            if (this.language == Language.Arabic) {
              filePath = `/${environment.resourcesRootPath}${serviceFolder}/assets/Resources/ar/${resourceFileName}.json?v=${new Date().getTime()}`;
            }
            else if (this.language == Language.English) {
              filePath = `/${environment.resourcesRootPath}${serviceFolder}/assets/Resources/en/${resourceFileName}.json?v=${new Date().getTime()}`;
            }
            else if (this.language == Language.Urdu) {
              filePath = `/${environment.resourcesRootPath}${serviceFolder}/assets/Resources/ur/${resourceFileName}.json?v=${new Date().getTime()}`;
            }
          }
          this.http.get<any>(filePath).subscribe(result => {
            observer.next(Object.assign(result, globalRes));
          }, error => {
            observer.error(error);
          });
        }, error => {
          observer.error(error);
        });
      });
    });
  }

  public getCurrentLanguage(): Language {
    return this.language;
  }
  private getCulture(): Observable<number> {
    return this.http.get<number>("/api/eservice/Common/GetCurrentLanguage");
  }

  private getGlobalResources(language: Language) {
    let filePath;
    //added below on 20240724 start
    if (window.location.href.toLowerCase().indexOf("/ar-ae/") > 0) {
      this.language = 1;
    }
    else if (window.location.href.toLowerCase().indexOf("/en/") > 0) {
      this.language = 2;
    }
    else if (window.location.href.toLowerCase().indexOf("/ur-pk/") > 0) {
      this.language = 3
    }
    //added below on 20240724 End
    if (this.language == Language.Arabic) {
      filePath = `/${environment.resourcesRootPath}${environment.globalResourcesFolder}/assets/Resources/ar/${environment.globalResourcesFileName}.json?v=${new Date().getTime()}`;
    }
    else if (this.language == Language.English) {
      filePath = `/${environment.resourcesRootPath}${environment.globalResourcesFolder}/assets/Resources/en/${environment.globalResourcesFileName}.json?v=${new Date().getTime()}`;
    }
    else if (this.language == Language.Urdu) {
      filePath = `/${environment.resourcesRootPath}${environment.globalResourcesFolder}/assets/Resources/ur/${environment.globalResourcesFileName}.json?v=${new Date().getTime()}`;
    }
    return this.http.get<any>(filePath);
  }
  public getCurrentLanguagePrefix(): string {
    let lang = this.languageList.filter(a => a.Id == this.language)
    if (lang.length > 0)
      return lang[0].Name
    else
      return "";
  }
}


